import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const StepBranch = ({ branches, onSelect }) => {
    const { t } = useTranslation();

    if (!branches || branches.length === 0) {
        return (
            <div className="text-center py-5">
                <i className="fa fa-store fa-3x text-muted mb-3"></i>
                <p className="text-muted">{t('booking.no_branches')}</p>
            </div>
        );
    }

    return (
        <div className="step-branch">
            <div className="step-header mb-4">
                <h4 className="step-title">
                    <i className="fa fa-store me-2 text-primary"></i>
                    {t('booking.select_branch')}
                </h4>
                <p className="step-subtitle text-muted">
                    {t('booking.select_branch_description')}
                </p>
            </div>

            <Row className="g-3">
                {branches.map((branch) => (
                    <Col md={6} lg={4} key={branch.id}>
                        <Card
                            className="branch-card h-100 cursor-pointer hover-shadow"
                            onClick={() => onSelect(branch)}
                        >
                            <Card.Body className="text-center p-4">
                                <div className="booking-branch-icon mb-3" aria-hidden="true">
                                    {/* SVG local evita dependência da versão/cache do Font Awesome nesta etapa pública. */}
                                    <svg viewBox="0 0 24 24" role="img">
                                        <path d="M4 22V2h11v4h5v16h-7v-4h-2v4H4Zm3-3h2v-2H7v2Zm0-4h2v-2H7v2Zm0-4h2V9H7v2Zm0-4h2V5H7v2Zm5 8h2v-2h-2v2Zm0-4h2V9h-2v2Zm0-4h2V5h-2v2Zm5 12h1v-2h-1v2Zm0-4h1v-2h-1v2Zm0-4h1V9h-1v2Z" />
                                    </svg>
                                </div>
                                <h5 className="branch-name mb-2">{branch.name}</h5>
                                {branch.address && (
                                    <p className="branch-address text-muted small mb-0">
                                        <i className="fa fa-map-marker-alt me-1"></i>
                                        {typeof branch.address === 'object'
                                            ? [branch.address.street, branch.address.number, branch.address.neighborhood, branch.address.city, branch.address.state].filter(Boolean).join(', ')
                                            : branch.address}
                                    </p>
                                )}
                                {branch.phone && (
                                    <p className="branch-phone text-muted small mb-0 mt-1">
                                        <i className="fa fa-phone me-1"></i>
                                        {branch.phone}
                                    </p>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default StepBranch;
